import { ActionTypes } from "./constants";

const setData = (payload) =>({ type: ActionTypes.SET_DATA, payload: payload });
const updateData = (payload) =>({ type: ActionTypes.UPDATE_DATA, payload: payload });
const setTblDataLoading = (payload) =>({ type: ActionTypes.SET_TBL_DATA_LOADING, payload: payload });

const exports = { 
    setData,
    updateData,
    setTblDataLoading
}

export default exports
